import "./styles.css";
let i = 0;
let j = 0;
let arr = [1, 2, 3, 4, 5, 6, 7, 8];
let index;

const app = document.getElementById("app");
const cell = document.querySelectorAll(".cell");
const name = document.querySelector(".name");
const button = document.querySelector(".submit");
let option = document.getElementById("option");

function changeSymbol(symbol) {
  if (i === 0) {
    symbol.innerText = option.options[option.selectedIndex].text;
    index = option.options.selectedIndex;
    console.log(symbol.innerText, option.options.index);
    option.style.pointerEvents = "none";
  } else {
    if (index === 1) {
      index = 0;
    } else {
      index = 1;
    }
    symbol.innerText = option.options.item(index).text;
    console.log(symbol.innerText, index);
  }
  i++;
}

function reset() {
  cell.forEach((box) => {
    box.style.pointerEvents = "none";
    box.style.backgroundColor = "#666";
  });
}

function loadGame() {
  option.style.pointerEvents = "auto";
  cell.forEach((box) => {
    box.innerText = "";
    box.style.pointerEvents = "auto";
    box.style.cursor = "pointer";
    box.style.backgroundColor = "black";
  });
}

function checkResult(symbolIndex) {
  j++;
  arr[symbolIndex] = [...cell][symbolIndex].innerText;
  if (
    (arr[3] === arr[4] && arr[4] === arr[5]) ||
    (arr[0] === arr[1] && arr[1] === arr[2]) ||
    (arr[6] === arr[7] && arr[7] === arr[8]) ||
    (arr[3] === arr[6] && arr[0] === arr[6]) ||
    (arr[4] === arr[7] && arr[1] === arr[7]) ||
    (arr[2] === arr[5] && arr[5] === arr[8]) ||
    (arr[0] === arr[4] && arr[4] === arr[8]) ||
    (arr[2] === arr[4] && arr[4] === arr[6])
  ) {
    j = 0;
    app.style.pointerEvents = "none";
    name.innerText = `${arr[symbolIndex]} win`;
    reset();
  }
  if (j === 9) {
    j = 0;
    name.innerText = "draw";
    reset();
  }
}

function newGame() {
  name.innerText = "Tic Tac Toe";
  app.style.pointerEvents = "auto";
  i = 0;
  j = 0;
  arr = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  loadGame();
}

cell.forEach((el, elIndex) => {
  el.addEventListener("click", function addText(event) {
    el.classList.add("no-click");
    el.style.pointerEvents = "none";
    el.style.backgroundColor = "#666";
    changeSymbol(el);
    checkResult(elIndex);
  });
});

button.addEventListener("click", newGame);
loadGame();
